import { useState, useEffect } from 'react';

interface UseOnlineStatusReturn {
  isOnline: boolean;
}

/**
 * Subscribes to window `online`/`offline` events and returns a reactive
 * boolean that updates without requiring a page refresh.
 */
export const useOnlineStatus = (): UseOnlineStatusReturn => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline };
};
